@if (retrieving) {
  <spinner messageRelativePosition="bottom"> </spinner>
}

@if (!retrieving) {
  <div class="flx-container">
    @if (!hideListingTitle) {
      <div class="flx-item">
        @if (listing) {
          <span class="title">
            {{ listing.title }}
          </span>
        }
      </div>
    }
    <div class="flx-break"></div>
    <div class="flx-item title">
      Check In / Check Out Configuration
      @if (isAdmin) {
        <help-link
          [url]="'https://www.notion.so/outdooraccess/Check-In-Check-Out-Listing-Configuration-37f448c037154e0ea9c7fcf525647aae'"
          [title]="'Check In / Check Out Listing Configuration Help Page'"
          >
        </help-link>
      }
    </div>
    <div class="flx-break"></div>
    <div class="flx-item flx-divider"></div>
    <div class="flx-break"></div>
    <div class="flx-item">
      <div class="checkbox-container">
        <div class="checkbox-container-item">
          <label>
            <input
              id="input-checkInEnabled"
              type="checkbox"
              [(ngModel)]="checkInEnabled"
              (ngModelChange)="onCheckboxStateChange($event, 'checkInEnabled')"
              />
              <!-- Check In Enabled -->
              Enabled
            </label>
            <!--
            <oa-checkbox [isChecked]="checkInEnabled" [label]="''" (stateChange)="onCheckboxStateChange($event, 'checkInEnabled')">
            </oa-checkbox> -->
          </div>
          <div class="flx-break"></div>
          <div class="checkbox-container-item flx-center center-block">
            <status-display [record]="modelPatchStatus" [propertyName]="'checkInEnabled'"></status-display>
          </div>
        </div>
      </div>
      <div class="flx-break"></div>
      <div class="flx-item">
        <div>
          <div class="checkbox-container">
            <div class="checkbox-container-item">
              <label>
                <input
                  id="input-checkInMemberNotifyEnabled"
                  [disabled]="!checkInEnabled"
                  type="checkbox"
                  [(ngModel)]="checkInMemberNotifyEnabled"
                  (ngModelChange)="onCheckboxStateChange($event, 'checkInMemberNotifyEnabled')"
                  />
                  Notify Primary Contact@if (primaryContact && primaryContact.fullName) {
                  <span> ({{ primaryContact.fullName }}) </span>
                  } When
                  Member Checks In or Out
                </label>
                <!--
                <oa-checkbox [isChecked]="checkInEnabled" [label]="''" (stateChange)="onCheckboxStateChange($event, 'checkInEnabled')">
                </oa-checkbox> -->
              </div>
              <div class="flx-break"></div>
              <div class="checkbox-container-item flx-center center-block">
                <status-display [record]="modelPatchStatus" [propertyName]="'checkInMemberNotifyEnabled'"></status-display>
              </div>
            </div>
            <div class="checkbox-container">
              <div class="checkbox-container-item">
                <label>
                  <input
                    [disabled]="!checkInEnabled"
                    id="input-checkInParticipantNotifyEnabled"
                    type="checkbox"
                    [(ngModel)]="checkInParticipantNotifyEnabled"
                    (ngModelChange)="onCheckboxStateChange($event, 'checkInParticipantNotifyEnabled')"
                    />
                    Notify Primary Contact@if (primaryContact && primaryContact.fullName) {
                    <span> ({{ primaryContact.fullName }}) </span>
                    } When
                    Guest Checks In or Out
                  </label>
                  <!--
                  <oa-checkbox [isChecked]="checkInEnabled" [label]="''" (stateChange)="onCheckboxStateChange($event, 'checkInEnabled')">
                  </oa-checkbox> -->
                </div>
                <div class="flx-break"></div>
                <div class="checkbox-container-item flx-center center-block">
                  <status-display [record]="modelPatchStatus" [propertyName]="'checkInParticipantNotifyEnabled'"></status-display>
                </div>
              </div>
              <div class="checkbox-container">
                <div class="checkbox-container-item">
                  <label>
                    <input
                      [disabled]="!checkInEnabled"
                      id="input-checkInOutPrimaryNotifyTextEnabled"
                      type="checkbox"
                      [(ngModel)]="checkInOutPrimaryNotifyTextEnabled"
                      (ngModelChange)="onCheckboxStateChange($event, 'checkInOutPrimaryNotifyTextEnabled')"
                      />
                      Notify Primary Contact@if (primaryContact && primaryContact.fullName) {
                      <span> ({{ primaryContact.fullName }}) </span>
                      } By Text
                      Message
                    </label>
                  </div>
                  <div class="flx-break"></div>
                  <div class="checkbox-container-item flx-center center-block">
                    <status-display [record]="modelPatchStatus" [propertyName]="'checkInOutPrimaryNotifyTextEnabled'"></status-display>
                  </div>
                </div>
                <div class="checkbox-container">
                  <div class="checkbox-container-item">
                    <label>
                      <input
                        [disabled]="!checkInEnabled"
                        id="input-checkInOutPrimaryNotifyEmailEnabled"
                        type="checkbox"
                        [(ngModel)]="checkInOutPrimaryNotifyEmailEnabled"
                        (ngModelChange)="onCheckboxStateChange($event, 'checkInOutPrimaryNotifyEmailEnabled')"
                        />
                        Notify Primary Contact@if (primaryContact && primaryContact.fullName) {
                        <span> ({{ primaryContact.fullName }}) </span>
                        } By Text
                        Message
                      </label>
                    </div>
                    <div class="flx-break"></div>
                    <div class="checkbox-container-item flx-center center-block">
                      <status-display [record]="modelPatchStatus" [propertyName]="'checkInOutPrimaryNotifyEmailEnabled'"></status-display>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flx-break"></div>
              <div class="flx-item text-muted">Configuration changes will only apply to future reservations</div>
              <div class="flx-break"></div>
              @if (!hideNavButtons) {
                <div class="flx-item">
                  <button class="btn btn-primary btn-round hvr-push" (click)="onBackToListingClick()">Back to Listing</button>
                </div>
              }
            </div>
          }
